type DeepStringify<T> = T extends string
  ? string
  : { [K in keyof T]: DeepStringify<T[K]> };

export const ja = {
  meta: {
    title: '3D マップエディタ',
  },
  menu: {
    play: 'クリックしてプレイ',
    view: '閲覧する',
    graphicsMenu: 'グラフィック設定',
    room: 'ルーム',
    join: '移動',
    playerName: 'プレイヤー名',
    change: '変更',
    sensitivity: 'マウス感度',
    graphics: '描画品質',
    depthOfField: 'ピンボケ（遠く／近く）',
    sunSdfShadows: '太陽のSDF',
    diSdfShadows: 'DIのSDF',
    giSdfShadows: 'GIのSDF',
    sdfAnalytic: 'SDFの解析枠',
    sdfAnalyticBvh: 'SDFのBVH',
    sdfVoxelSpheres: 'SDFのボクセル球',
    sunlight: '太陽光',
    ambient: '間接光',
    giDiffuseGain: 'GI 拡散ゲイン',
    giDistanceAmbient: '遠距離の固定環境光',
    giNearAmbient: '近距離の固定環境光',
    denoiser: '点光源デノイズ',
    restirCheapVisibility: 'ReSTIR 安い候補陰影',
    collisionDebug: '当たり判定のみ',
    language: '言語',
    players: 'このルームのプレイヤー',
    controlsMenu: '操作方法',
    credits: 'クレジット',
    textureCredit: 'テクスチャ素材',
  },
  status: {
    connecting: '接続中…',
    open: '接続済み',
    closed: '切断（自動で再接続します）',
  },
  graphics: {
    kicker: 'GRAPHICS',
    title: 'グラフィック設定',
    closeHint: 'で閉じる',
    low: '低',
    medium: '中',
    high: '高',
    on: 'オン',
    off: 'オフ',
    denoiserOff: 'オフ',
    denoiserTemporal: '時間のみ',
    denoiserSvgf: 'SVGF',
    denoiserSvgfSharp: 'SVGF sharp',
    denoiserRelax: 'RELAX',
    reset: '初期値に戻す',
  },
  controls: {
    kicker: 'CONTROLS',
    title: '操作方法',
    closeHint: 'で閉じる',
  },
  playerlist: {
    room: 'ルーム',
    self: '{name}（自分）',
    menuHeading: '{label}（{count}）',
    emptyConnecting: '接続中…',
    emptyClosed: '切断中（再接続します）',
  },
  viewHint: '閲覧中 · クリックでプレイ · Esc でメニュー',
  mobile: {
    jump: 'ジャンプ',
    moveAria: '移動',
  },
  inventory: {
    kicker: 'CREATIVE LOADOUT',
    title: 'インベントリ',
    closeHint: 'で閉じる',
    catalogAria: '配置できるアイテム',
    instruction: 'アイテムを下のホットバーへドラッグして配置します。',
    tablistAria: 'アイテム種別',
    tabBrace: 'ブレース',
    tabPlane: 'プレーン',
    tabPolygon: 'ポリゴン',
    tabStair: '階段',
    tabObject: 'オブジェクト',
    tabTool: 'ツール',
    tabTexture: 'テクスチャ作成',
    previewAria: '作成中テクスチャのプレビュー',
    allFaces: '全6面共通',
    name: '名前',
    list: 'リスト',
    newListName: '新しいリスト名',
    listPlaceholder: '例: 石材',
    color: '色',
    pattern: 'パターン',
    resolution: '解像度',
    noiseScale: 'ノイズスケール',
    noiseContrast: 'ノイズのコントラスト',
    motif: '模様',
    reroll: '⚄ ノイズを引き直す',
    create: '作成',
    selected: '選択中',
    slot: 'スロット {n}',
    hotbar: 'ホットバー',
    invertHotbarScroll: 'ホイールでスロットを逆順にする',
    dragAria: '{label}をホットバーへドラッグ',
    tool: 'ツール',
    empty: '空',
    emptyNote: '固定の空手。アイテムやツールは置けない。ハイライトや設置プレビューも出さない。',
    destroyNote: '照準中のオブジェクトをクリックで壊します。',
    rangeDestroyNote: '照準位置をグリッドの 1/2 マスにスナップし、2回クリックでグリッド向きの箱に重なるオブジェクトを壊します。',
    copyPasteNote: '2点でグリッド向きの箱を切り、視線が当たる形と重なったものをこのスロットへコピーします。点はスナップせず照準位置です。同じ点を2回クリックすると、1点目で目線の先にあった1つだけをコピーします。',
    clipboardNote: 'コピーした物体全体の AABB で置きます。地面では底面、天井では上面が面に揃います。回転は視線の水平向きで 0° / 90° / 180° / 270° です。Q でコピーモードに戻ります。',
    braceBendNote: 'ブレースまたはプレーンの1辺をクリックし、もう一点を曲がる側にすると、その辺を短い円弧に曲げます。直角二等辺になる位置なら90°です。ブレースの制御点は二端点の垂直二等分面上、プレーンは同一平面上の二等分線上です。',
    extrudeNote: 'プレーンまたはブレースをクリックします。プレーンは法線方向の長さ、ブレースは近い頂点からもう一点へのオフセットで紙の折れ面になります。曲げと同時に持てます。輪郭や頂点の近くをクリックすると押し出しを外します。',
    extrudeUpNote: 'プレーンまたは同一平面上のブレースをクリックすると、プレイヤー側へスナップ長だけ押し出します。プレーンは面の法線、2点ブレースは上下だけ、折れ線は折れ線平面の垂線です。地面の上にいれば上、下にいれば下、側面なら手前に突き出します。クリックするたびにスナップ長を足せます。',
    extrudeDownNote: 'プレーンまたは同一平面上のブレースをクリックすると、プレイヤーと反対側へスナップ長だけ押し出します。プレーンは面の法線、2点ブレースは上下だけ、折れ線は折れ線平面の垂線です。地面の上にいれば下、下にいれば上、側面なら奥へ突き出します。クリックするたびにスナップ長を足せます。',
    holeNote: 'プレーン、押し出したプレーン、押し出したブレースの面上に閉じた折れ線を描きます。始点をクリックすると、面の垂線方向に立体を貫く穴が開きます。面からはみ出す輪郭は置けません。',
    clothSimNote: 'プレーンまたはブレースをクリックすると設定ダイアログが開きます。立体はふくらませ、一枚は辺を止めて垂らせます。ブレースは両端を止めて電線のように垂らせます。元の形は残したまま結果ポリゴンを保存します。同じツールで再度クリックすると別設定で焼き直せます。',
    revolveNote: 'プレーンまたは同一平面上のブレースの1辺をクリックすると、その辺を軸に360°回した回転体になります。塗った面は立体、折れ線は曲面です。同じ辺をもう一度クリックすると平面に戻ります。押し出し・穴・クロス付きは対象外です。',
    objectNote: 'クリックした面に置きます。椅子は直立のまま、照明は面に取り付けます。',
    width: '幅',
    height: '高さ',
    rotation: '回転（度）',
    thickness: '厚み',
    snap: 'スナップ',
    light: '光源',
    water: '水面',
    newTexture: '新しいテクスチャ',
    newList: '新しいリスト…',
    slotTitle: '{n}: {title}',
    materialTitle: '{material} / {shape}',
  },
  shape: {
    brace: 'ブレース',
    plane: 'プレーン',
    polygon: 'ポリゴン',
    stair: '階段',
    object: 'オブジェクト',
  },
  object: {
    'box-upright': '椅子',
    'box-fixture': '照明箱',
  },
  tool: {
    empty: 'なし',
    destroy: '破壊',
    rangeDestroy: '範囲破壊',
    copyPaste: 'コピペ',
    clipboard: 'コピー',
    clipboardCount: 'コピー {count}',
    braceBend: '曲げ',
    extrude: '押し出し',
    extrudeUp: '上に押し出し',
    extrudeUpSnap: '上に押し出し {snap}',
    extrudeDown: '下に押し出し',
    extrudeDownSnap: '下に押し出し {snap}',
    hole: '穴開け',
    clothSim: 'クロスシミュ',
    revolve: '回転体',
  },
  toast: {
    notConnected: 'サーバーに接続されていません。',
    rangeNeedSurface: 'グリッド、プレーン、ブレースの面を指定してください。',
    rangeDestroyFirstPoint: '範囲破壊: 1点目を選びました。終点に照準を合わせてクリックしてください。',
    rangeDestroyTooLarge: '範囲が大きすぎます（最大 {max} m³）。',
    copyPasteFirstPoint: 'コピペ: 基準点を選びました。反対側の角に照準を合わせてクリックしてください。',
    copyPasteEmpty: 'コピーできるものがありません。',
    copyPasteTooLarge: '範囲が大きすぎます（最大 {max} m³）。',
    braceBendNeedBrace: '曲げるにはブレースまたはプレーンの辺を照準してください。',
    braceBendFirstPoint: '曲げ: 辺を選びました。曲がる側をクリックしてください。',
    braceBendDegenerate: 'その位置では円弧を作れません。線分の外を指定してください。',
    extrudeNeedTarget: '押し出すにはプレーンまたはブレースを照準してください。',
    extrudeFirstPlane: '押し出し: プレーンを選びました。法線方向の長さをクリックしてください。',
    extrudeFirstBrace: '押し出し: 頂点を選びました。押し出す先をクリックしてください。',
    extrudeDegenerate: 'その位置では押し出せません。輪郭や頂点から離してください。',
    extrudeUpDegenerate: '面からプレイヤー側へは押し出せません。同一平面上にない折れ線や上限を超える長さは対象外です。',
    extrudeDownDegenerate: '面からプレイヤーと反対側へは押し出せません。同一平面上にない折れ線や上限を超える長さは対象外です。',
    holeNeedTarget: '穴を開けるにはプレーン、押し出したプレーン、または押し出したブレースの面を照準してください。',
    holeTooFewPoints: '穴には3点以上が必要です。',
    holeOutside: '穴は面の内側に収めてください。',
    holeDegenerate: 'その輪郭では穴を開けられません。自己交差や面積0の多角形は使えません。',
    holeTooManyPoints: '穴の頂点が多すぎます。',
    holeTooMany: 'これ以上穴を開けられません。',
    clothSimNeedFill: 'クロスシミュはプレーンまたはブレースを照準してください。',
    clothSimFailed: 'その形状ではシミュレーションできません。',
    revolveNeedEdge: '回転体にするにはプレーンまたは同一平面上のブレースの辺を照準してください。',
    revolveHasExtrude: '押し出し済みは回転できません。先に押し出しを外してください。',
    revolveHasHoles: '穴のある形は回転できません。',
    revolveHasCloth: 'クロス焼きのある形は回転できません。',
    revolveNotPlanar: '同一平面上にない折れ線は回転できません。',
    revolveArcAxis: '円弧の辺は軸にできません。直線の辺を選んでください。',
    revolveCleared: '回転体を外して平面に戻しました。',
    revolveNoBend: '回転体は曲げられません。先に回転を外してください。',
    samePoint: '始点と終点が同じ位置です。',
    braceNeedPoints: 'ブレースの折れ線には2点以上が必要です。',
    braceTooManyPoints: 'ブレースの頂点が多すぎます。',
    planeNeedPoints: 'ポリゴンには3点以上が必要です。',
    planeTooManyPoints: 'プレーンの頂点が多すぎます。',
    notPlanar: '点が同一平面上にありません。',
    colinear: '点が一直線に並んでいるため面を作れません。',
    stairNeedHorizontal: '階段は水平方向の距離が必要です。',
    noDestroyTool: 'ホットバーに破壊ツールがありません。',
    creatingTexture: '「{name}」を作成しています…',
    createdTexture: '「{name}」を作成しました。',
    textureAdded: '「{name}」がルームに追加されました。',
    peerJoined: '{name} が参加しました',
    peerLeft: '{name} が退出しました',
    invalidRoom: 'ルーム名は英数字・ハイフン・アンダースコアのみ（64文字以内）です。',
    roomRequiresLogin: 'ロビー以外のルームには、ログインが必要です。',
    graphicsReset: 'グラフィック設定を初期値に戻しました',
  },
  item: {
    graphicsQuality: '描画品質: {label}',
    depthOfField: 'ピンボケ: {label}',
    sunSdfShadows: '太陽のSDF: {label}',
    diSdfShadows: 'DIのSDF: {label}',
    giSdfShadows: 'GIのSDF: {label}',
    sdfAnalytic: 'SDFの解析枠: {label}',
    sdfAnalyticBvh: 'SDFのBVH: {label}',
    sdfVoxelSpheres: 'SDFのボクセル球: {label}',
    sunlight: '太陽光: {label}',
    ambient: '間接光: {label}',
    giDiffuseGain: 'GI拡散ゲイン: {label}',
    giDistanceAmbient: '遠距離環境光: {label}',
    giNearAmbient: '近距離環境光: {label}',
    denoiser: 'デノイズ: {label}',
    restirCheapVisibility: 'ReSTIR安い候補陰影: {label}',
    collisionDebug: '当たり判定のみ: {label}',
    invertHotbarScroll: 'スロットのホイール: {label}',
    flyOn: '飛行モード ON',
    flyOff: '飛行モード OFF',
    held: '{shape}: {label}  ({summary})',
  },
  build: {
    braceSummary: '太さ {thickness} / スナップ {snap} / {count} 点',
    planeSummary: '厚み {thickness} / スナップ {snap} / {mode} / {count} 点',
    planeModeRect: '3点',
    polygonSummary: '厚み {thickness} / スナップ {snap} / {count} 点',
    enterToPlace: 'Enterキーで設置',
    stairSummary: 'スナップ {snap} / 3点 / {count} 点',
    objectSummary: 'スナップ {snap}',
    clipboardSummary: 'スナップ {snap} / {count} 個',
    holeSummary: 'スナップ {snap} / {count} 点',
    gridTarget: 'グリッド {i}, {j} / {side}',
    gridBelow: '下面',
    gridAbove: '上面',
    lightCount: '光源 {count}',
    shapeLine: '{shape}  ·  {summary}',
  },
  gridEditor: {
    title: '視点グリッド',
    subtitle: '自分だけに見える正方格子。他の人には送りません。',
    heightY: '高さ Y',
    snap: '間隔',
    hide: '表示しない',
    walkOn: '上を歩けます。下からは突き抜けます。',
    invalidNumber: '数値を入力してください。',
    hidden: 'グリッドを非表示にしました。線も床もありません。',
    rotation: '回転（度）',
    closeHint: 'で閉じる',
  },
  clothSim: {
    title: 'クロスシミュレーション',
    subtitle: '一度変形し、結果のポリゴンを保存します。元の形はそのまま残ります。',
    resolution: '解像度',
    steps: 'ステップ',
    shape: '形',
    shapeVolume: '立体',
    shapeSheet: '一枚',
    pin: '固定辺',
    pinNone: 'なし',
    pinTop: '上',
    pinBottom: '下',
    pinLeft: '左',
    pinRight: '右',
    pinEnds: '両端',
    gather: '寄せ',
    inflate: 'ふくらみ',
    gravity: '重力',
    stiffness: '硬さ',
    preview: 'プレビュー',
    run: '実行',
    running: '実行中…',
    cancel: 'キャンセル',
    progress: '{percent}%',
    closeHint: 'で閉じる',
  },
  texture: {
    defaultList: 'デフォルト（{name}）',
  },
  texturePattern: {
    plain: '無地',
    outline: '1px外周',
    'double-outline': '二重外周',
    inset: '凹パネル',
    'horizontal-stripes': '横ストライプ',
    'vertical-stripes': '縦ストライプ',
    'diagonal-stripes': '斜めストライプ',
    checker: '市松模様',
    grid: 'グリッド',
    bricks: 'レンガ積み',
    planks: '板張り',
    dots: 'ドット',
  },
  control: {
    touch: 'スマホ: <b>スティック</b> 移動 / 右の<b>ジャンプ</b> / ボタン以外をドラッグで視点（インベントリなし）',
    move: '<b>W A S D</b> 移動 / <b>Space</b> ジャンプ / <b>Shift</b> しゃがみ（グリッドに乗っているときはすり抜け）',
    fly: '<b>Space×2</b> または <b>F</b> で飛行モード切替（飛行中は Space 上昇・Shift 下降）',
    sprint: '<b>Ctrl</b> または <b>W×2</b> でダッシュ',
    click: '<b>クリック</b>（左右共通）選択中スロットの操作 / <b>ホイールクリック</b> 素材をコピー',
    hotbar: '<b>0〜9</b>・<b>ホイール</b> スロットの持ち替え（初期0は空、1は破壊ツール）',
    destroy: '<b>X</b> ホットバーの破壊ツールへ切替 / <b>Z</b> ひとつ前のスロットへ戻る',
    inventory: '<b>E</b> インベントリを開く / アイテム・ツールをホットバーへドラッグして配置',
    graphics: '<b>V</b> グラフィック設定',
    brace:
      '<b>クリック</b> 折れ線でブレースを設置 / <b>Enter</b> または最後の頂点クリックで確定、始点クリックで閉じる / <b>Backspace</b> 直前の点を取消 / <b>Q</b> 作図中止',
    plane:
      '<b>クリック</b> 3点で長方形のプレーンを設置 / <b>Backspace</b> 直前の点を取消 / <b>Q</b> 作図中止',
    polygon:
      '<b>クリック</b> 多角形のポリゴンを設置 / <b>Enter</b> または最後の頂点クリックで確定、始点クリックで閉じる / <b>Backspace</b> 直前の点を取消 / <b>Q</b> 作図中止',
    stair: '<b>クリック</b> 3点で階段を設置（最初の2点で幅、3点目で長さ） / <b>Backspace</b> 直前の点を取消 / <b>Q</b> 作図中止',
    thickness: '<b>Ctrl+ホイール</b> または <b>[ ]</b> 太さ調整 / <b>G</b> 視点グリッド',
    extra: '<b>Tab</b> 参加者一覧 / <b>F3</b> デバッグ表示',
    menu: '<b>Esc</b> このメニュー（閲覧中も同様）',
  },
  material: {
    default: 'コンクリート',
    wood: '木材',
    metal: '金属',
    brick: 'レンガ',
    glass: 'ガラス',
    grass: '芝',
    stone: '石',
    accent: 'アクセント',
    sand: '砂',
    light: '発光素材',
    black: '黒',
    scaffold: '足場',
    water: '水面',
    'laminated-wood': '積層木材',
    'metal-bump': 'バンプメタル',
    'metal-horizontal-bump': '横縞バンプメタル',
    'metal-horizontal': '横縞メタル',
    'terrazzo-curved': '曲線テラゾ',
    'terrazzo-long': '長尺テラゾ',
    'terrazzo-rough': '粗目テラゾ',
    'terrazzo-tiles': 'テラゾタイル',
    'weaved-basket': '籠編み',
    'concrete-stones-01': 'コンクリート石',
    'decorative-bricks-01': '装飾レンガ',
    'paint-copper-01': '塗装銅',
    'plaster-01': '漆喰',
    'sidewalk-brick-tiles-01': '歩道レンガタイル1',
    'sidewalk-brick-tiles-02': '歩道レンガタイル2',
    'sidewalk-brick-tiles-03': '歩道レンガタイル3',
    'sidewalk-tiles-01': '歩道タイル',
    'tiles-01': 'タイル',
    'bricks-destroyed': '崩れたレンガ',
    'bricks-destroyed-plaster': '崩れた漆喰レンガ',
    'colored-tiles-small': '色タイル（小）',
    'fabric-square-patterrn': '四角模様ファブリック',
    'ground-bricks-herringbone': 'ヘリンボーンレンガ',
    'terrazo-tiles-decorative': '装飾テラゾ',
    'terrazo-tiles-gray': '灰色テラゾ',
    'armor-scales-decorated': '装飾鱗甲',
    'armor-scales-simple': '鱗甲',
    'decorative-ceramic-tiles': '装飾セラミックタイル',
    'decorative-concrete-bricks': '装飾コンクリートレンガ',
    'decorative-fabric': '装飾ファブリック',
    'leather-cross': '十字レザー',
    'leather-straps': 'レザーストラップ',
    'leather-straps-pattern': 'レザーストラップ模様',
    'metal-grater': 'グレーターメタル',
    'ceramic-tiles-circular': '円形セラミックタイル',
    'dark-wood-floor-tiles': '暗い木の床タイル',
    'decorative-bathroom-tiles': '浴室タイル',
    'decorative-black-tiles': '黒タイル',
    'old-rug-brown': '茶色の古いラグ',
    'retractable-security-door': 'セキュリティドア',
    'window-grill': '窓格子',
    'wodden-framed-window': '木枠窓',
    'wodden-framed-windows': '木枠窓（連）',
    'concrete-fish-tiles': '魚模様コンクリート',
    'leather-couchin-perfored': '穴あきレザー',
    'leather-couchin-perfored-diamond': 'ダイヤ穴あきレザー',
    'leather-couchin-rectangle': '四角レザー',
    'leather-couchin-scales': '鱗レザー',
    'metal-cooper-grid': '銅グリッド',
    'stylized-clover-ground': 'クローバー地面',
    'terrazo-and-white-tiles': '白タイル混テラゾ',
    'tire-rubber': 'タイヤゴム',
    'fabric-decorative-01': '装飾ファブリック1',
    'fabric-decorative-02': '装飾ファブリック2',
    'fabric-decorative-03': '装飾ファブリック3',
    'fabric-scify-01': 'SFファブリック',
    'fabric-wool-01': 'ウール',
    'floor-tiles-and-bricks': 'タイルとレンガの床',
    'leather-couching-01': 'キルティングレザー',
    'wall-plaster-stones': '漆喰石壁',
    'windows-blue-old': '古い青窓',
    'metal-grid-clover': 'メタルグリッド（クローバー）',
    'metal-grid-cross': 'メタルグリッド（十字）',
    'metal-grid-spikes': 'メタルグリッド（スパイク）',
    'metal-grid-square': 'メタルグリッド（四角）',
    'metal-grid-square-white': 'メタルグリッド（白四角）',
    'metal-grid-wave': 'メタルグリッド（波）',
    'metal-shutter-cross-bars': 'シャッター（十字）',
    'metal-shutter-perfored-roller': 'シャッター（穴あき）',
    'metal-shutter-perfored-roller-big': 'シャッター（大穴）',
    'metal-tiles-solded': '溶接メタルタイル',
    'metal-triangle-solded': '溶接三角メタル',
    'metal-zinc-rough': '粗い亜鉛',
    sponge: 'スポンジ',
    'stone-floor-polished': '磨き石床',
    'tiles-basic-01': 'ベーシックタイル',
    'tiles-diamond-moon': 'ダイヤタイル',
    'tiles-marble-01': '大理石タイル1',
    'tiles-marble-02': '大理石タイル2',
    'concrete-destroyed-wall-01': '崩れたコンクリート壁',
    'old-bricks-01': '古いレンガ',
    'stone-engrave-wall-01': '彫刻石壁',
    'wood-and-bricks-floor-01': '木とレンガの床',
    'wooden-floor-painted-01': '塗装木の床',
    'wooden-floor-01': '木の床1',
    'wooden-floor-02': '木の床2',
    'wooden-floor-03': '木の床3',
    'wooden-floor-04': '木の床4',
    'stone-tiles-01': '石タイル1',
    'stone-tiles-02': '石タイル2',
    'stone-tiles-03': '石タイル3',
    'stone-tiles-04': '石タイル4',
    'stone-tiles-05': '石タイル5',
    'stone-tiles-06': '石タイル6',
    'stone-tiles-07': '石タイル7',
    'stone-tiles-08': '石タイル8',
    'stone-tiles-09': '石タイル9',
    'base-white-tile': '白いタイル',
  },
  pack: {
    'mix-pack-02': 'Tiles & Metal',
    'mix-pack-01': 'Tiles & Stones',
    'mix-pack-03': 'Tiles & Roaches',
    'mix-pack-04': 'Leather & Metal',
    'mix-pack-05': 'Wood & Windows',
    'mix-pack-06': 'Mix Pack 06',
    'mix-pack-07': 'Mix Pack 07',
    'metal-pack-02': 'Metal Grids',
    'tiles-and-metals': 'Metal & Tiles',
    'wood-and-bricks': 'Bricks & Wood',
    'stone-tiles': 'Stone Tiles',
    'base-white-tile': 'White Tile',
  },
} as const;

export type Messages = DeepStringify<typeof ja>;
